export default __webpack_public_path__ + "media/images/footer-logo-4e121850ab04a3aae93bb9d6c06f9f7b.png";